import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fontsCarmaTitle.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/CarmaTitleCompact-ExtraBold.woff2%22,%22style%22:%22normal%22,%22weight%22:%22800%22}],%22display%22:%22fallback%22,%22variable%22:%22--font-carmatitle%22}],%22variableName%22:%22carmaTitleFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'carmaTitleFont', 'carmaTitleFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
